import React from "react";
import { useAuth } from "../utils/Auth/AuthWrapper";
import { Navigate } from "react-router-dom";

type Props = {};

const LandingPage = (props: Props) => {
  const auth = useAuth();

  return (
    <>
      {auth.user == null ? (
        <Navigate to="/" replace={true} />
      ) : auth.user.role == "User" ? (
        <Navigate to="/" replace={true} />
      ) : (
        <Navigate to="/" replace={true} />
      )}
      {/* <Navigate to="/home" replace={true} /> */}
    </>
  );
};

export default LandingPage;
